export default __webpack_public_path__ + "static/media/RecordsIcom.1003383a.svg";